import React from "react";
import { ButtonProps } from "../../../interfaces/Button.interface";
import { ButtonSizeTypes } from "../../../interfaces/enums/ButtonSizeTypes.enum";
import { ButtonTypes } from "../../../interfaces/enums/ButtonTypes.enum";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import { StoryblokAsset } from "../../../interfaces/Storyblok/StoryblokAsset.interface";
import Button from "../../atoms/Button/Button.component";
import Image from "../../atoms/Image/Image.atom";

export interface ColumnedInfoCardProps extends Blok {
  image?: StoryblokAsset;
  label?: string;
  heading?: string;
  body?: string;
  cta?: ButtonProps[];
}

const ColumnedInfoCard: React.FC<ColumnedInfoCardProps> = ({ _uid, image, label, heading, body, cta }) => {
  const hasCta = Array.isArray(cta) && cta.length > 0 && !!cta[0].label && !!cta[0].link?.cached_url;

  return (
    <li key={_uid} className="flex flex-col space-y-4">
      {image?.filename && (
        <div className="aspect-video w-full overflow-hidden rounded-6xl">
          <Image image={image} objectFit="cover" />
        </div>
      )}

      <div className="flex flex-1 flex-col space-y-3">
        {label && <p className="text-sm font-bold uppercase tracking-wide text-Primary-500">{label}</p>}
        {heading && <h3 className="text-xl font-extrabold text-Primary-900 xl:text-2xl">{heading}</h3>}
        {body && <p className="text-Body">{body}</p>}
      </div>

      {hasCta && (
        <div className="pt-2">
          <Button link={cta[0].link} label={cta[0].label} type={ButtonTypes.PRIMARY} size={ButtonSizeTypes.DEFAULT} />
        </div>
      )}
    </li>
  );
};

export default ColumnedInfoCard;
